import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import {
  Title,
  Description,
  Img,
  Wrapper,
  TitleWrapper,
  ButtonWrapper,
} from './styled'

type LeadProposalFullRegistrationDrawerProps = {
  isShow: boolean
  onCancel: () => void
}

export function LeadProposalFullRegistrationDrawer({
  isShow,
  onCancel,
}: LeadProposalFullRegistrationDrawerProps) {
  const driverTaxiparkId = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getMainTaxiparkId(),
  )
  return (
    <DrawerComponent
      isShow={isShow}
      onCancel={onCancel}
      contentProps={{
        className: 'ion-content-scroll-host',
        style: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
    >
      <Wrapper>
        <TitleWrapper>
          <Title data-testid='booking-car-register-drawer-title'>
            Для аренды автомобиля остался всего один шаг!
          </Title>
          <Description>
            Перейдите к полной регистрации и заполните все данные
          </Description>
        </TitleWrapper>

        <Img src='/images/bookingCarRegister.png' alt='' />

        <ButtonWrapper>
          <Button
            size='large'
            fullWidth
            variant='limeFlooded'
            to={`/registration?taxiparkId=${driverTaxiparkId}`}
            style={{ marginBottom: '12px' }}
          >
            Перейти к регистрации
          </Button>

          <Button
            size='large'
            fullWidth
            variant='lightSteelBlueBorder'
            onClick={onCancel}
            style={{ marginBottom: '12px' }}
          >
            Закрыть
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </DrawerComponent>
  )
}
